
import { lazy } from 'react';

// Helper function to retry failed dynamic imports
const retryImport = <T,>(importFn: () => Promise<T>, retries = 3): Promise<T> => {
  return importFn().catch((error) => {
    if (retries > 0) {
      console.warn(`Dynamic import failed, retrying... (${retries} attempts left)`, error);
      return new Promise(resolve => {
        setTimeout(() => resolve(retryImport(importFn, retries - 1)), 1000);
      });
    }
    console.error('Dynamic import failed after all retries:', error);
    // Fallback to page reload if all retries fail
    window.location.reload();
    throw error;
  });
};

// Ленивая загрузка основных страниц с retry logic
export const LazyDashboard = lazy(() => retryImport(() => import('@/pages/Dashboard')));
export const LazyMain = lazy(() => retryImport(() => import('@/pages/Main')));
export const LazyClients = lazy(() => import('@/pages/Clients'));
export const LazyOrders = lazy(() => import('@/pages/Orders'));
export const LazyRentals = lazy(() => import('@/pages/Rentals'));
export const LazyInventory = lazy(() => import('@/pages/Inventory'));
export const LazyStore = lazy(() => import('@/pages/Store'));
export const LazySettings = lazy(() => import('@/pages/Settings'));
export const LazyTasks = lazy(() => import('@/pages/Tasks'));
export const LazyReports = lazy(() => import('@/pages/Reports'));

export const LazyNotifications = lazy(() => import('@/pages/Notifications'));

// Тестовые страницы


// Профильные страницы
export const LazyProfile = lazy(() => import('@/pages/Profile'));
export const LazyProfileAdmin = lazy(() => import('@/pages/ProfileAdmin'));
export const LazyProfileManager = lazy(() => import('@/pages/ProfileManager'));


// Рентальные страницы
export const LazyRentalCalendar = lazy(() => import('@/pages/RentalCalendar'));
export const LazyRentalKits = lazy(() => import('@/pages/RentalKits'));
export const LazyRentalDenials = lazy(() => import('@/pages/RentalDenials'));
export const LazyCrossLocationRental = lazy(() => import('@/pages/CrossLocationRental'));
export const LazyWorkshop = lazy(() => import('@/pages/Workshop'));

// Админские страницы
export const LazyRequestCenter = lazy(() => import('@/pages/RequestCenter'));
export const LazyStaffManagement = lazy(() => import('@/pages/StaffManagement'));

// Поисковые страницы
export const LazySearchResults = lazy(() => import('@/pages/SearchResults'));
